import { z } from 'zod';

export const transferSchema = z.object({
  province: z.string().min(1, 'Province is required').trim(),
  district: z.string().min(1, 'District is required').trim(),
  sector: z.string().min(1, 'Sector is required').trim(),
  cell: z.string().min(1, 'Cell is required').trim(),
  village: z.string().min(1, 'Village is required').trim()
});

export type TransferFormValues = z.infer<typeof transferSchema>;
